'use strict';

angular.module('amexReconciliationApp')
  .service('AdobeAnalyticsService', function ($window, $rootScope, $analytics, UserModel) {
    var self = this;

    UserModel.onCurrentUserChanged($rootScope, function(newUser) {
      var companyId = _.get(newUser, 'companyId', '(unknown)');
      if($window.digitalData )
      $window.digitalData.page.category.subCategory1 = 'Company:' + companyId;
    });

    self.setActiveTabForAnalytics = function (tabName) {
          if (typeof $window.appVars === 'undefined') {
              $window.appVars = {
                  'transactionTab': tabName
              };
          } else {
              $window.appVars.transactionTab = tabName;
          }
      };

    self.eventTrack = function (event , eventAsset) {
        $analytics.eventTrack(event,eventAsset);
    };
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/AdobeAnalyticsService.js
// module id = 633
// module chunks = 0